<template>
  <footer class="bg-grey text-white p-4 text-center text-md-start">
    <div class="container">
      <div class="row">
        <div class="col-md-1 col-lg-3"></div>
        <div class="col-md-5 col-lg-3 order-3 order-md-2">
          <h2 class="text-white">Elérhetőségek</h2>
          <p><b>Cím:</b><br />1134 Budapest Váci út 23-27.</p>
          <p><b>Telefonszám:</b><br />+36 1 460 1400</p>
          <p><b>E-mail cím:</b><br />info@colonnade.hu</p>
        </div>
        <div class="col-md-5 col-lg-3 order-2 order-md-3 mb-5 mb-md-0">
          <div class="d-flex flex-column justify-content-center align-items-center h-100">
            <img class="w-100 mb-3" :src="'./assets/colonnade_logo.png'" alt="Colonnade logo" />
            <p>
              <b
                ><a
                  class="text-decoration-none text-white"
                  href="https://colonnade.hu/media/adatkezelesi-tajekoztato.pdf"
                  target="_blank"
                  >Adatkezelési tájékoztató</a
                ></b
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
.bg-grey {
  background-color: #666666;
}
</style>
